import { formatInTimeZone } from 'date-fns-tz'
import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { RouteDetails } from '@/types/routeDetails'
import { useDateStore } from '@/components/DateInput'

export const GET_ROUTE_DETAILS_KEY = 'GET_ROUTE_DETAILS_KEY'

export const useGetRouteDetails = (route?: string) => {
    const { date } = useDateStore()
    const formattedDate = formatInTimeZone(date, 'UTC', 'yyyy-MM-dd')

    return useAppQuery<RouteDetails>({
        queryKey: [GET_ROUTE_DETAILS_KEY, route],
        queryFn: () =>
            createInstance({
                url: `routes/${route}/strategy`,
                method: 'GET',
                params: {
                    Date: formattedDate,
                },
            }),
        staleTime: Infinity,
        enabled: !!route,
    })
}
